import React from "react";

const EstadisticasIcon = () => (
  <svg
    style={{ color: "#0f0f0f", fontSize: "16px", width: "16px", height: "16px" }}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 19.2h16" />
    <path d="M7 16V10.2" />
    <path d="M12 16V6.5" />
    <path d="M17 16v-3.8" />
    <path d="M6.8 10.1l4.2-3.3 3.7 1.9 3.5-3.2" />
  </svg>
);

export default EstadisticasIcon;
